import { render, staticRenderFns } from "./TaxCalculatorContent.vue?vue&type=template&id=7402a15a&scoped=true&"
import script from "./TaxCalculatorContent.vue?vue&type=script&lang=ts&"
export * from "./TaxCalculatorContent.vue?vue&type=script&lang=ts&"
import style0 from "./TaxCalculatorContent.vue?vue&type=style&index=0&id=7402a15a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7402a15a",
  null
  
)

export default component.exports